// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2ujUq","errorLogs":"EditorFooter_errorLogs__2rpyf"};